import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import { getSpecificDateWithDays } from "../../../core/et3-date";
import { isDateRangeValid } from "../../../helpers/et3-date-helper";
import { TKhattabatMatchmakingAuditRow } from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";
import { apiCallGetKhattabatMatchmakingAudit } from "../../../api/khattbat-api/api-call-get-khattabat-matchmaking-audit";

class MatchmakingAuditStore {
  matchmakingAuditData = observable.box<TKhattabatMatchmakingAuditRow[]>([]);
  matchmakingAuditFromDate = observable.box<Date>(
    getSpecificDateWithDays({
      daysSubtracted: 1,
      daysAdded: 0
    })
  );
  matchmakingAuditToDate = observable.box<Date>(
    getSpecificDateWithDays({ daysSubtracted: 0, daysAdded: 1 })
  );

  setMatchmakingAuditData = (data: TKhattabatMatchmakingAuditRow[]) => {
    runInAction(() => {
      this.matchmakingAuditData.set(data);
    });
  };

  getMatchmakingAuditData = async () => {
    this.setMatchmakingAuditData([]);

    if (
      !isDateRangeValid({
        fromDate: this.matchmakingAuditFromDate.get(),
        toDate: this.matchmakingAuditToDate.get(),
        isLimitedToOneMonth: false
      })
    ) {
      return;
    }

    getCoreUIStore().setIsLoading("KHATTABAT_MATCHMAKING_AUDIT", true);
    const { data, status, code } = await apiCallGetKhattabatMatchmakingAudit({
      startDate: this.matchmakingAuditFromDate.get(),
      endDate: this.matchmakingAuditToDate.get()
    });
    getCoreUIStore().setIsLoading("KHATTABAT_MATCHMAKING_AUDIT", false);

    if (status === "ERROR") {
      return getCorePopUpStore().showAlertMessage(code);
    }

    this.setMatchmakingAuditData(data);
  };
}

export const getMatchmakingAuditStore = memoize(
  () => {
    return new MatchmakingAuditStore();
  },
  () => 1
);

export default getMatchmakingAuditStore;
